import {computed, Ref} from "vue";
import useExperimentalFeatures from "@/core/composables/experimental-features/useExperimentalFeatures";
import {cacheKey} from "@/lib/cache";
import useSwr from "@/core/composables/swr/useSwr";
import {contestApi} from "@/container";

export interface ContestTableOptions {
    page: number;
    itemsPerPage: number;
}

const useContestsProgress = (
    status: Ref<'ended' | 'upcoming' | null>,
    options: Ref<ContestTableOptions>
) => {
    const {enabled} = useExperimentalFeatures();

    const swrKey = computed(() => {
        return cacheKey('contests-progress', {
            status: status.value,
            page: options.value.page,
            limit: options.value.itemsPerPage,
            ...(enabled.value ? {experimental: true} : {})
        });
    });

    const {data, isLoading, mutate} = useSwr(
        () => swrKey.value,
        () => {
            return contestApi().indexWithProgress({
                status: status.value,
                page: options.value.page,
                limit: options.value.itemsPerPage,
                ...(enabled.value ? {experimental: true} : {})
            });
        }
    );

    const contests = computed(() => data.value?.data ?? []);
    const totalItems = computed(() => data.value?.meta?.total ?? 0);

    return {contests, totalItems, isLoading, mutate};
};

export default useContestsProgress;


